import React from 'react';

import * as Styles from './styles';

export default function Background() {
    return (
        <Styles.Background />
    );
}
